module.exports = __webpack_public_path__ + "assets/img/serivce.38a18be1.png";